import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { api, ApiException } from '../api/client';
import NewPageDialog from './NewPageDialog';
export default function PagesSidebar({ selectedSlug, refreshKey = 0, onPageDeleted }) {
    const [pages, setPages] = useState(null);
    const [error, setError] = useState(null);
    const [openMenu, setOpenMenu] = useState(null);
    const [showNew, setShowNew] = useState(false);
    const navigate = useNavigate();
    async function refresh() {
        try {
            const { pages } = await api.listPages();
            setPages(pages);
        }
        catch (e) {
            setError(e instanceof ApiException ? e.message : 'Failed to load');
        }
    }
    useEffect(() => { refresh(); }, [refreshKey]);
    async function createPage(payload) {
        await api.createPage(payload);
        setShowNew(false);
        await refresh();
        navigate(`/pages/${payload.slug}`);
    }
    async function deletePage(slug) {
        if (!window.confirm(`Move "${slug}" to trash? Page JSON is moved to pages/.trash/, content folder is preserved.`))
            return;
        try {
            await api.deletePage(slug);
            await refresh();
            onPageDeleted?.(slug);
            if (selectedSlug === slug)
                navigate('/pages');
        }
        catch (e) {
            alert(e?.message ?? 'Delete failed');
        }
        setOpenMenu(null);
    }
    return (_jsxs("aside", { className: "pages-sidebar", children: [_jsxs("div", { className: "sidebar-head", children: [_jsx("span", { className: "sidebar-title", children: "Pages" }), _jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 6 }, children: [pages && _jsx("span", { className: "tag", children: pages.length }), _jsx("button", { className: "ghost icon-btn", title: "New page", onClick: () => setShowNew(true), children: "+" })] })] }), error && _jsx("div", { className: "err pad small", children: error }), !pages && !error && _jsx("div", { className: "muted pad small", children: "Loading\u2026" }), pages && (_jsx("ul", { className: "pages-list", children: pages.map((p) => (_jsxs("li", { className: `page-li ${openMenu === p.slug ? 'menu-open' : ''}`, children: [_jsxs(NavLink, { to: `/pages/${p.slug}`, className: ({ isActive }) => (isActive || p.slug === selectedSlug) ? 'page-row active' : 'page-row', children: [_jsx("span", { className: "page-title", title: p.title, children: p.title }), _jsxs("span", { className: "page-meta", children: [_jsxs("span", { className: "slug", children: ["/", p.slug === 'home' ? '' : p.slug] }), _jsx("span", { className: "count", children: p.block_count })] })] }), _jsx("button", { type: "button", className: "page-menu-btn", "aria-label": `Actions for ${p.slug}`, onClick: (e) => { e.preventDefault(); setOpenMenu((cur) => cur === p.slug ? null : p.slug); }, children: "\u22EF" }), openMenu === p.slug && (_jsx("div", { className: "page-menu", onClick: (e) => e.stopPropagation(), children: _jsx("button", { onClick: () => deletePage(p.slug), className: "danger", children: "Delete (move to trash)" }) }))] }, p.slug))) })), showNew && _jsx(NewPageDialog, { onCreate: createPage, onClose: () => setShowNew(false) })] }));
}
